<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div :id="id"></div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import 'grapesjs/dist/css/grapes.min.css';
  import grapesjs from "grapesjs";
  import config from "./config";
  import assets from "./mixins/assets";
  import content from "./mixins/content";
  import variables from "./mixins/variables";
  export default {
    name: "VHtmlBuilder",
    props: {
      id: {
        type: String,
        required: true
      },
      project: {
        type: String,
        required: true,
        default: 'web'
      },
    },
    mixins: [assets, content, variables],
    async mounted() {
      setTimeout(async () => {
        const editor = grapesjs.init({
          container: `#${this.id}`,
          ...config,
        });
        await this.initAssets(editor);
        await this.initContent(editor);
        await this.initVariables(editor);
      });
    },
  }
</script>
<style scoped>
</style>
